import sale from '@/api/report/sale'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  }
}

export const actions = {
  // generate daily sale item pdf
  visitation(context, data) {
    return sale.visitation(data)
  },
  visitationExcel(context, data) {
    return sale.visitationExcel(data)
  },
  detailSaleByProduct(context, attributes = {}) {
    return sale.detailSaleByProduct({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  detailSaleByProductExcel(context, data) {
    return sale.detailSaleByProductExcel(Object.assign({
      date_from: context.state.date_from,
      date_to: context.state.date_to
    }, data))
  },
  detailStockReturnByProduct(context, attributes = {}) {
    return sale.detailStockReturnByProduct({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  detailStockReturnByProductExcel(context, data) {
    return sale.detailStockReturnByProductExcel(Object.assign({
      date_from: context.state.date_from,
      date_to: context.state.date_to
    }, data))
  },

  getUser(context, attributes = {}) {
    return sale.user(attributes)
  },
  detailSaleByCustomer(context, attributes = {}) {
    return sale.detailSaleByCustomer({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  detailSaleByCustomerExcel(context, data) {
    return sale.detailSaleByCustomerExcel(Object.assign({
      date_from: context.state.date_from,
      date_to: context.state.date_to
    }, data))
  },
  detailSaleByImei(context, attributes = {}) {
    return sale.detailSaleByImei({
      params: Object.assign(
        {
          date_from: context.state.date_from,
          date_to: context.state.date_to
        },
        attributes
      )
    })
  },
  detailSaleByImeiExcel(context, data) {
    return sale.detailSaleByImeiExcel(Object.assign({
      date_from: context.state.date_from,
      date_to: context.state.date_to
    }, data))
  },
  saleSummary(context, attributes = {}) {
    return sale.saleSummary({
      params: Object.assign(
        {
          date_range: attributes.date_range
        },
        attributes
      )
    })
  },
  saleSummaryExcel(context, data) {
    return sale.saleSummaryExcel(data)
  },

  dailySaleExcel(context, data) {
    return sale.dailySaleExcel(data)
  }
}
